import React from 'react';
import { Avatar, SxProps, Theme } from '@mui/material';
import DiceBearAvatar from './DiceBearAvatar';
import { mapLegacyConfigToDicebear } from '../../utils/avatarMapping';
import type { LegacyAvatarConfig } from '../../utils/avatarMapping';

interface UserAvatarUser {
  full_name: string;
  avatar_config?: Record<string, any> | null;
}

interface UserAvatarProps {
  user: UserAvatarUser;
  size?: number;
  sx?: SxProps<Theme>;
}

const PALETTE = [
  '#1565c0',
  '#2e7d32',
  '#e65100',
  '#6a1b9a',
  '#b71c1c',
  '#00695c',
  '#4e342e',
  '#37474f',
];

function getColor(name: string): string {
  const code = (name || 'A').charCodeAt(0);
  return PALETTE[code % PALETTE.length];
}

function hasConfig(config?: Record<string, any> | null): boolean {
  return !!config && Object.keys(config).length > 0;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 32, sx }) => {
  if (hasConfig(user.avatar_config)) {
    const legacyConfig = user.avatar_config as LegacyAvatarConfig;
    const dicebearConfig = mapLegacyConfigToDicebear(legacyConfig);
    
    return (
      <DiceBearAvatar
        seed={user.full_name}
        config={dicebearConfig}
        size={size}
        sx={sx}
      />
    );
  }

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: getColor(user.full_name),
        fontSize: size * 0.4,
        flexShrink: 0,
        ...(sx as object),
      }}
    >
      {(user.full_name || '?').charAt(0).toUpperCase()}
    </Avatar>
  );
};

export default UserAvatar;
